import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo du Maire Accueil ", -1)
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Deuxième Photo du Maire ", -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Photo de la SE ", -1)
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Valeur ", -1)
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Vision ", -1)
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mission ", -1)
const _hoisted_26 = { class: "mb-0" }
const _hoisted_27 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Historique ", -1)
const _hoisted_31 = { class: "mb-0" }
const _hoisted_32 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot du Maire Accueil ", -1)
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_38 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Le Maire ", -1)
const _hoisted_40 = { class: "mb-0" }
const _hoisted_41 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_42 = { class: "col-md-12" }
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Publication de la SE ", -1)
const _hoisted_45 = { class: "mb-0" }
const _hoisted_46 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_47 = { class: "col-md-12" }
const _hoisted_48 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mentions Légales ", -1)
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_52 = { class: "col-md-12" }
const _hoisted_53 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Données personnelles ", -1)
const _hoisted_55 = { class: "mb-0" }
const _hoisted_56 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_57 = { class: "col-md-12" }
const _hoisted_58 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Cookies ", -1)
const _hoisted_60 = { class: "mb-0" }
const _hoisted_61 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_62 = { class: "col-md-12" }
const _hoisted_63 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Organigramme ", -1)
const _hoisted_65 = { class: "col-md-12" }
const _hoisted_66 = { class: "d-flex align-items-center" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "aproposForm",
        onSubmit: _ctx.editApropos,
        "validation-schema": _ctx.aproposSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  name: "urlImage",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Choisir une image"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "urlImage",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  name: "urlImage2",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Choisir une image"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "urlImage2",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, {
                  name: "Image",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Choisir une image"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "Image",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_QuillEditor, {
                    theme: "snow",
                    ref: "valeurEditor",
                    placeholder: "Écrire la valeur",
                    toolbar: "full",
                    name: "valeur"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Ce champ est obligatoire"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "valeur",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_QuillEditor, {
                    theme: "snow",
                    ref: "visionEditor",
                    placeholder: "Écrire la vision",
                    toolbar: "full",
                    name: "vision"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, "Ce champ est obligatoire"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "vision",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_QuillEditor, {
                    theme: "snow",
                    ref: "missionEditor",
                    placeholder: "Écrire la mission",
                    toolbar: "full",
                    name: "mission"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Ce champ est obligatoire"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "mission",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_QuillEditor, {
                    theme: "snow",
                    placeholder: "Écrire l'historique",
                    toolbar: "full",
                    name: "historique",
                    ref: "historiqueEditor"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, "Ce champ est obligatoire."))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "mission",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_QuillEditor, {
                    theme: "snow",
                    placeholder: "Écrire l'annonce du Directeur Général",
                    toolbar: "full",
                    name: "annoncedg",
                    ref: "annoncedgEditor"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_37, "La publication est obligatoire."))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "annoncedg",
                  class: "text-danger"
                })
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_QuillEditor, {
                    theme: "snow",
                    placeholder: "Écrire l'annonce du Directeur Général",
                    toolbar: "full",
                    name: "annoncedg2",
                    ref: "annoncedgEditor2"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, "La publication est obligatoire."))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "annoncedg2",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_QuillEditor, {
                    theme: "snow",
                    placeholder: "Publication de  la sécrétaire",
                    toolbar: "full",
                    name: "publication",
                    ref: "publicationEditor"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_46, "La publication est obligatoire."))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "annoncedg",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_QuillEditor, {
                    ref: "mentionLegaleEditor",
                    theme: "snow",
                    placeholder: "Renseigner les mentions",
                    toolbar: "full",
                    name: "mentionLegale"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_51, "Ce champ est obligatoire."))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "mentionLegale",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_QuillEditor, {
                    ref: "donnePersonnelleEditor",
                    theme: "snow",
                    placeholder: "Renseigner les données personnelles",
                    toolbar: "full",
                    name: "donnePersonnelle"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_56, "Ce champ est obligatoire."))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "donnePersonnelle",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_QuillEditor, {
                    ref: "cookieEditor",
                    theme: "snow",
                    placeholder: "Écrire les cookies",
                    toolbar: "full",
                    name: "cookie"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_61, "Ce champ est obligatoire"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "cookie",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _createVNode(_component_Field, {
                  name: "image",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Choisir une image"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "image",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSubmit()))
                }, " Modifier "),
                _createVNode(_component_router_link, {
                  to: "/liste-apropos",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_67,
                    _hoisted_68,
                    _createTextVNode("Annuler")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}